module.exports = __webpack_public_path__ + "static/media/35.bc0c7849.jpg";